import { Component, Inject, ElementRef, Optional, OnInit,ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { first } from 'rxjs/operators';
import {MatSnackBar} from '@angular/material/snack-bar';
import { MarcoDeReferencia } from 'app/main/models/marco-de-referencia.model';
import { Sentencia } from 'app/main/models/sentencia.model';
import {FormControl} from '@angular/forms';
import {MatAutocompleteSelectedEvent, MatAutocomplete} from '@angular/material/autocomplete';
import {MatChipInputEvent} from '@angular/material/chips';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import { TablaDeEvaluacion } from 'app/main/models/tabla-de-evaluacion.model';
import { OpcionValor } from 'app/main/models/opcion-valor.model';
import { Opcion } from 'app/main/models/opcion.model';


@Component({
  selector: 'app-dialog-box-add-node',
  templateUrl: './dialog-box-add-node.component.html',
  styleUrls: ['./dialog-box-add-node.component.scss']
})
export class DialogBoxAddNodeComponent {

  action: string;
  LOCAL_DATA: any;
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  nombreOrigen = "";
  tablasDeEvaluacion: TablaDeEvaluacion[] = [];
  tablaSeleccionada: TablaDeEvaluacion = null;

  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  constructor(
    public translate: TranslateService,
    public dialogRef: MatDialogRef<DialogBoxAddNodeComponent>,
    private _snackBar: MatSnackBar,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    console.log(data);
    this.dialogRef.disableClose = true;
    this.tablasDeEvaluacion = data.tablas;
    delete data["tablasDeEvaluacion"];
    this.LOCAL_DATA = data.obj;
    this.action = data.action;
  }

  doAction(): void{
    this.dialogRef.close({event: this.action, data: this.LOCAL_DATA});
  }

  closeDialog(): void{
    this.dialogRef.close({event: 'Cancel'});
  }

  ngOnInit(): void {

  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 3000,
    });
  }

  compareObjects(o1: any, o2: any): boolean {
    var equals = false;
    if(o1!=null && o2!=null && typeof o1 === 'object' &&  typeof o2 === 'object' && 'id' in o1 && 'id' in o2 && o1.id === o2.id){
      equals = true;
    }else{
      equals = (o1 == o2)? true:false;
    }

    return equals;
  }



}
